'use client';

import type {
  EndpointDetectionFindingDto,
  EndpointDetectionSignalDto,
} from '@terra/shared-contracts-endpoints';

export type DetectionHoverType = 'finding' | 'signal';

export type SortedEndpointDetectionFinding = EndpointDetectionFindingDto;

export type SortedEndpointDetectionSignal = EndpointDetectionSignalDto;

export const sortDetectionsByActiveFirst = <
  TItem extends { isActive: boolean },
>({
  items,
}: {
  items: TItem[];
}): TItem[] =>
  [...items].sort(
    (firstItem, secondItem) =>
      Number(secondItem.isActive) - Number(firstItem.isActive),
  );
